import * as React from 'react';
import { formatPhone } from '../../utils/formatters';
import { getRegionPhone, Region } from '../../utils/regions';
import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';

const styles = require('./phone.css');

interface IPhoneProps {
  regionId: Region;
}

class PhonePure extends React.PureComponent<IPhoneProps, object> {
  public render() {
    const { regionId } = this.props;
    const phone = getRegionPhone(regionId);

    return (
      <a href={`tel:${phone}`} className={styles['phone']}>
        {formatPhone(phone)}
      </a>
    );
  }
}

export const Phone = connect((state: IApplicationState) => ({
  regionId: state.filter.query.region,
}))(PhonePure);
